import React, { useEffect, useState, useRef } from "react";
import Industry from "./../../assets/Industries/terex/maindining (2).webp";

const ContactHero = () => {
  const text = "Industries we work with";
  const words = text.split(" "); // Split text into words for animation
  const [isVisible, setIsVisible] = useState(false);
  const heroRef = useRef(null);

  useEffect(() => {
    // Define keyframes dynamically
    const fadeInKeyframes = `
      @keyframes fadeInWord {
        from {
          opacity: 0;
          transform: translateY(20px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
    `;

    // Inject keyframes into the document head
    const styleSheet = document.createElement("style");
    styleSheet.type = "text/css";
    styleSheet.innerHTML = fadeInKeyframes;
    document.head.appendChild(styleSheet);

    return () => {
      document.head.removeChild(styleSheet);
    };
  }, []);

  useEffect(() => {
    // IntersectionObserver to detect when 30% of hero section is visible
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (heroRef.current) observer.observe(heroRef.current);

    return () => {
      if (heroRef.current) observer.unobserve(heroRef.current);
    };
  }, []);

  // 🎯 Ultra-Smooth Scrolling with requestAnimationFrame
  const smoothScrollTo = (targetPosition, duration = 800) => {
    const startPosition = window.scrollY;
    const distance = targetPosition - startPosition;
    let startTime = null;

    function animationStep(timestamp) {
      if (!startTime) startTime = timestamp;
      const timeElapsed = timestamp - startTime;
      const progress = Math.min(timeElapsed / duration, 1);

      // Ease-in-out quadratic function for smooth scrolling
      const easeInOutQuad =
        progress < 0.5
          ? 2 * progress * progress
          : -1 + (4 - 2 * progress) * progress;

      window.scrollTo(0, startPosition + distance * easeInOutQuad);

      if (timeElapsed < duration) {
        requestAnimationFrame(animationStep);
      }
    }

    requestAnimationFrame(animationStep);
  };

  // 📌 Scroll to Contact Form Section
  const scrollToContactForm = (e) => {
    e.preventDefault();
    const section = document.getElementById("industry");
    if (section) {
      const yOffset = section.getBoundingClientRect().top + window.scrollY - 100;
      smoothScrollTo(yOffset, 1000); // 🔥 Smooth scroll in 1s
    } else {
      console.error("❌ #contact-form not found!");
    }
  };

  return (
    <section ref={heroRef} style={styles.heroContainer}>
    <img src={Industry} alt="Hero Background" style={styles.backgroundImage} />
      <div>
        <h1 style={styles.heading}>
          {words.map((word, index) => (
            <span
              key={index}
              style={{
                opacity: isVisible ? 1 : 0,
                display: "inline-block",
                animation: isVisible ? `fadeInWord 0.6s forwards` : "none",
                animationDelay: isVisible ? `${index * 0.3}s` : "0s",
                marginRight: "10px", // Space between words
              }}
            >
              {word}
            </span>
          ))}
        </h1>
        <p style={styles.subText}>We’d love to hear from you! Reach out today.</p>
        <a href="industry" style={styles.button} onClick={scrollToContactForm}>
          Contact Us
        </a>
      </div>
    </section>
  );
};

// Inline styles
const styles = {
  // heroContainer: {
  //   width: "100vw",
  //   height: "100vh", // Ensures full screen height
  //   backgroundImage: `url(${Industry})`,
  //   backgroundSize: "cover",
  //   backgroundPosition: "center",
  //   display: "flex",
  //   justifyContent: "center",
  //   alignItems: "center",
  //   textAlign: "center",
  //   color: "white",
  //   position: "relative",
  //   margin: 0,
  //   padding: 0,
  //   overflow: "hidden", // Prevents scrolling issues
  // },
  heroContainer: {
    width: "100vw",
    height: "100vh",
    position: "relative",
    display: "flex",
    color: "white",
    position: "relative",
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
    margin: 0,
    padding: 0,
    overflow: "hidden",
  },
  heading: {
    fontSize: "clamp(2.5rem, 6vw, 4rem)", // Responsive font size
    fontWeight: "bold",
    marginBottom: "10px",
    wordWrap: "break-word",
  },
  subText: {
    fontSize: "1.5rem",
    marginBottom: "20px",
  },
  button: {
    display: "inline-block",
    padding: "12px 30px",
    fontSize: "1.2rem",
    color: "#fff",
    backgroundColor: "#d72638", // Primary color
    borderRadius: "5px",
    textDecoration: "none",
    fontWeight: "bold",
    transition: "background 0.3s ease",
    cursor: "pointer",
  },

  backgroundImage: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
    zIndex: -1,
  },
  
  content: {
    zIndex: 1,
    color: "white",
    textAlign: "center",
    padding: "20px",
  },
  
};

export default ContactHero;
